import { Box } from '@mui/material';
import { MprcContainer, MprcRequestErrorDialog } from 'components';
import { MprcFilterBox, MprcFilterCount } from 'components/filter';
import { MprcRibbonListCardsExpandedContainer } from "components/MprcRibbonList";
import { MprcRibbonListCardsGridContainer } from 'components/MprcRibbonList/MprcRibbonListCardContainers';
import { MprcSearchTextField, MprcSearchTextFieldHandle } from 'components/MprcSearchTextField';
import { CardDto, CarouselCardRenderMode } from 'generated/CoreApi_v1';
import TzUtils from 'lib/TzUtils';
import { isCanceledError, useCoreApi } from 'providers/CoreApiProvider';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseComponentHeader } from 'views/common/components/BaseComponentHeader';
import { useGobackOrLms } from 'views/common/hooks/useGobackOrHome';
import { GeneralCardLoading } from 'views/general/Cards';
import { CardDtoToCardRibbon } from 'views/general/Cards/CardDtoToCardRibbon';

////////////////////////////////////////////////////////////////////////////////

export const LmsCarouselTrainingMandatory = () => {
    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const [searchText, setSearchText] = useState<string>("");
    const [viewError, setViewError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [viewData, setViewData] = useState<CardDto[]>([]);
    const [reload, setReload] = useState<boolean>(false);

    const searchTextField = useRef<MprcSearchTextFieldHandle | null>(null);
    const abortControllerRef = useRef<AbortController | undefined>(undefined);

    const goBackOrHome = useGobackOrLms();

    ///
    async function loadCarousel() {

        setLoading(true);

        // Tenta obter a configuração do cache local.
        // Se o cache expirou OU há um novo dado Sensível, obtém uma nova configuração da página.
        try {

            abortControllerRef.current?.abort();

            abortControllerRef.current = new AbortController();

            const response = await api.v1.lmsStudent.getCarouselTrainingMandatory({
                searchText: searchText,
                browserTimeZoneId: TzUtils.browserTimezone(),
            }, { signal: abortControllerRef.current.signal });

            setViewData(response.data);
            setLoading(false);
        }
        catch (e) {
            if (!isCanceledError(e)) {
                setViewError(e);
                setViewData([]);
                setLoading(false);
            }
        }
        finally {
            abortControllerRef.current = undefined;
        }
    }

    ///
    const resetFilters = () => {
        searchTextField.current?.reset();
    };

    ///
    const filtered = !loading && searchText.length > 0;

    ///
    useEffect(() => {
        loadCarousel();
    }, [searchText, reload]);


    ///
    return (
        <>
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />

            <BaseComponentHeader
                title={t("Student.Carousel.Mandatory")}
                recordChanged={false}
                onBack={() => goBackOrHome()}
            />

            <MprcRibbonListCardsExpandedContainer>

                <Box sx={{ mb: 2 }}>
                    <MprcContainer>
                        <MprcFilterBox>
                            <MprcSearchTextField
                                autoFocus
                                ref={searchTextField}
                                placeholder={t("shared:Search.TextPlaceholder")}
                                confirmMode="debounce"
                                onConfirm={(text) => setSearchText(text)}
                            />
                        </MprcFilterBox >
                    </MprcContainer>

                    <MprcFilterCount
                        loading={loading}
                        isEmpty={viewData.length == 0}
                        countText={t("Student.Catalog.RecordsFoundText", { count: viewData.length })}
                        filter={{
                            active: filtered,
                            text: t("Student.Catalog.RecordsFilteredText", { count: viewData.length }),
                            onResetFilter: resetFilters
                        }}
                    />
                </Box>

                <MprcRibbonListCardsGridContainer>
                    {
                        loading
                            ? <GeneralCardLoading />
                            : CardDtoToCardRibbon(
                                viewData
                                , CarouselCardRenderMode.Default
                                , {
                                    onFullReload: () => setReload(true),
                                    onCarouselReload: () => setReload(true),
                                })
                    }
                </MprcRibbonListCardsGridContainer>

            </MprcRibbonListCardsExpandedContainer>
        </>
    );
};
